module.exports = __webpack_public_path__ + "static/img/car_4reflect.bbce468.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/car_4reflect.png
// module id = nsJv
// module chunks = 1